import { AreaConfig } from '#server/models';
import { useAdminSubjectDraft } from '@/contexts';
import { toSlug } from '@/lib/utils';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { Select } from '@/components/ui/select';
import { Label } from '@/components/ui/label';

interface Step1Props {
  areaConfig: AreaConfig;
}

export const Step1BasicDetails = ({ areaConfig }: Step1Props) => {
  const { draft, updateDraft } = useAdminSubjectDraft();

  const handleTitleChange = (title: string) => {
    updateDraft({ title, slug: toSlug(title) });
  };

  return (
    <div className="space-y-5">
      <h2 className="text-base font-semibold text-[#E8E8E8]">Step 1 – Basic Details</h2>

      <div className="space-y-1">
        <Label className="text-[#999]">Title</Label>
        <Input
          value={draft.title}
          onChange={(e) => handleTitleChange(e.target.value)}
          className="bg-[#2A2A2A] border-[#444] text-[#E8E8E8]"
          placeholder="e.g. Ankle Joint"
        />
      </div>

      <div className="space-y-1">
        <Label className="text-[#999]">Slug</Label>
        <Input
          value={draft.slug}
          onChange={(e) => {
            const sanitised = e.target.value.toLowerCase().replace(/[^a-z0-9-]/g, '');
            updateDraft({ slug: sanitised });
          }}
          className="bg-[#2A2A2A] border-[#444] text-[#E8E8E8]"
          placeholder="e.g. ankle-joint"
        />
      </div>

      <div className="space-y-1">
        <Label className="text-[#999]">Type</Label>
        <Select
          value="3D"
          disabled
          className="bg-[#2A2A2A] border-[#444] text-[#E8E8E8] opacity-60 cursor-not-allowed"
        >
          <option value="3D">3D</option>
        </Select>
        <p className="text-xs text-[#666]">Only 3D {areaConfig.subjectName.plural.toLowerCase()} can be created through this wizard.</p>
      </div>

      <div className="space-y-1">
        <Label className="text-[#999]">Discipline</Label>
        <Select
          value={draft.disciplineId ?? ''}
          onChange={(e) => updateDraft({ disciplineId: e.target.value ? Number(e.target.value) : null })}
          className="bg-[#2A2A2A] border-[#444] text-[#E8E8E8]"
        >
          <option value="">— select discipline —</option>
          {areaConfig.disciplines.map((d) => (
            <option key={d.id} value={d.id}>{d.name}</option>
          ))}
        </Select>
      </div>

      <div className="space-y-1">
        <Label className="text-[#999]">Description</Label>
        <Textarea
          value={draft.description}
          onChange={(e) => updateDraft({ description: e.target.value })}
          className="bg-[#2A2A2A] border-[#444] text-[#E8E8E8]"
          placeholder={`${areaConfig.subjectName.singular} description…`}
          rows={4}
        />
      </div>
    </div>
  );
};
